import React from "react";

import { AgreementSection } from "./AgreementSection";

export default {
  title: "Authentication/SignUpForm/AgreementSection",
  component: AgreementSection,
  decorators: [
    (story) => {
      return <div style={{ padding: "3rem" }}>{story()}</div>;
    },
  ],
};

const Template = (args) => {
  return <AgreementSection {...args} />;
};

export const Default = Template.bind({});
Default.args = {};
